import React from "react";
import PatientTypePage from "../components/PatientType";

// update log
// FB 4371 DK    03/29/2021    Added to invoke the patient type component

export default function InofficePage(data: any) {
  return <PatientTypePage {...data} />;
}
